import hljs from "highlight.js/lib/core";
import json from "highlight.js/lib/languages/json";
import http from "highlight.js/lib/languages/http";
import javascript from "highlight.js/lib/languages/javascript";
import python from "highlight.js/lib/languages/python";
import bash from "highlight.js/lib/languages/bash";

hljs.registerLanguage("json", json);
hljs.registerLanguage("http", http);
hljs.registerLanguage("bash", bash);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("python", python);

export type ExampleFormat = "HTTP" | "cURL" | "JSON" | "JavaScript" | "Python";

/** highlight.js escapes source text before adding its own token spans. */
export function highlightExample(text: string, format: ExampleFormat): string {
  if (format === "HTTP") {
    const separator = text.indexOf("\n\n");
    if (separator !== -1) {
      return (
        hljs.highlight(text.slice(0, separator), {
          language: "http",
          ignoreIllegals: true,
        }).value +
        "\n\n" +
        hljs.highlight(text.slice(separator + 2), {
          language: "json",
          ignoreIllegals: true,
        }).value
      );
    }
  }
  return hljs.highlight(text, {
    language: {
      HTTP: "http",
      cURL: "bash",
      JSON: "json",
      JavaScript: "javascript",
      Python: "python",
    }[format],
    ignoreIllegals: true,
  }).value;
}
